/*
 * Custom JavaScript
 * Use this file to add your own custom JavaScript code.
 */

/* Add your custom JavaScript below this line */

/* ProDiagAuto : bulle d'invitation fixe en bas a droite, au-dessus du chat Shopify Inbox.
   Elle reste affichee et se ferme uniquement avec la croix. */
(function () {
  if (window.Shopify && Shopify.designMode) return;
  var KEY = 'pda_chat_bubble_closed';
  try { if (sessionStorage.getItem(KEY)) return; } catch (e) {}

  var css = document.createElement('style');
  css.textContent =
    '#pda-chat-bubble{position:fixed;right:16px;bottom:96px;left:auto;top:auto;z-index:2147483000;max-width:230px;' +
    'background:#fff;color:#0e2238;border-radius:14px;padding:12px 36px 12px 14px;' +
    'box-shadow:0 6px 24px rgba(14,34,56,.18);font:500 14px/1.4 system-ui,-apple-system,sans-serif;' +
    'cursor:pointer;opacity:0;transform:translateY(8px);transition:opacity .3s,transform .3s}' +
    '#pda-chat-bubble.pda-show{opacity:1;transform:translateY(0)}' +
    '#pda-chat-bubble:after{content:"";position:absolute;right:26px;bottom:-7px;width:14px;height:14px;' +
    'background:#fff;transform:rotate(45deg);box-shadow:3px 3px 6px rgba(14,34,56,.08)}' +
    '#pda-chat-bubble .pda-close{position:absolute;top:2px;right:4px;border:0;background:none;' +
    'font-size:22px;line-height:1;color:#64748b;cursor:pointer;padding:6px 8px}';
  document.head.appendChild(css);

  function openInbox() {
    var host = document.querySelector('inbox-online-store-chat');
    var root = host && (host.shadowRoot || host);
    var btn = root && root.querySelector('button');
    if (btn) btn.click();
  }

  setTimeout(function () {
    var b = document.createElement('div');
    b.id = 'pda-chat-bubble';
    b.setAttribute('role', 'button');
    b.innerHTML = 'Une question ? Je vous aide à choisir votre kit 👋' +
      '<button type="button" class="pda-close" aria-label="Fermer">×</button>';
    b.querySelector('.pda-close').addEventListener('click', function (e) {
      e.stopPropagation();
      b.classList.remove('pda-show');
      setTimeout(function () { b.remove(); }, 300);
      try { sessionStorage.setItem(KEY, '1'); } catch (e2) {}
    });
    b.addEventListener('click', openInbox);
    document.body.appendChild(b);
    requestAnimationFrame(function () { b.classList.add('pda-show'); });
  }, 5000);
})();

/* ProDiagAuto : animations lavage - bulles de savon (contour dore), reflet brillant, bulles au clic panier.
   Visibles sur telephone ET ordinateur. Desactivees si le visiteur a demande moins d'animations. */
(function () {
  if (window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var css = document.createElement('style');
  css.textContent =
    '.pda-bubbles{position:absolute;inset:0;overflow:hidden;pointer-events:none;z-index:1}' +
    '.pda-bubble{position:absolute;bottom:-70px;border-radius:50%;border:2px solid #C9A24B;' +
    'background:radial-gradient(circle at 30% 30%,rgba(255,255,255,.95) 0 10%,rgba(255,255,255,.35) 22%,rgba(201,162,75,.10) 70%,rgba(201,162,75,.28) 100%);' +
    'box-shadow:inset 0 0 8px rgba(201,162,75,.45),0 2px 8px rgba(201,162,75,.40);' +
    'animation:pda-rise linear forwards}' +
    '@keyframes pda-rise{0%{transform:translate(0,0) scale(.6);opacity:0}8%{opacity:1}' +
    '50%{transform:translate(var(--dx),-55vh) scale(1)}90%{opacity:.9}' +
    '100%{transform:translate(calc(var(--dx)*-1),-110vh) scale(1.05);opacity:0}}' +
    '.pda-shine{position:relative;overflow:hidden}' +
    '.pda-shine:after{content:"";position:absolute;top:0;left:-75%;width:50%;height:100%;pointer-events:none;z-index:2;' +
    'background:linear-gradient(110deg,transparent 0,rgba(255,255,255,0) 30%,rgba(255,255,255,.55) 50%,rgba(255,255,255,0) 70%,transparent 100%);' +
    'animation:pda-shine 6s ease-in-out infinite;animation-delay:var(--sd,0s)}' +
    '@keyframes pda-shine{0%,70%{left:-75%}100%{left:130%}}' +
    '.pda-pop{position:fixed;border-radius:50%;pointer-events:none;z-index:2147483001;border:2px solid #C9A24B;' +
    'background:radial-gradient(circle at 30% 30%,#fff 0 12%,rgba(255,255,255,.4) 40%,rgba(201,162,75,.25) 100%);' +
    'animation:pda-pop .9s ease-out forwards}' +
    '@keyframes pda-pop{0%{transform:translate(0,0) scale(.3);opacity:1}100%{transform:translate(var(--px),var(--py)) scale(1.1);opacity:0}}';
  document.head.appendChild(css);

  var mobile = window.innerWidth < 750;

  function addBubbles(zone) {
    if (!zone || zone.querySelector('.pda-bubbles')) return;
    if (getComputedStyle(zone).position === 'static') zone.style.position = 'relative';
    var layer = document.createElement('div');
    layer.className = 'pda-bubbles';
    zone.appendChild(layer);
    function spawn() {
      if (document.hidden) return;
      var b = document.createElement('span');
      var size = 14 + Math.random() * (mobile ? 30 : 44);
      var dur = 6 + Math.random() * 6;
      b.className = 'pda-bubble';
      b.style.width = b.style.height = size + 'px';
      b.style.left = Math.random() * 95 + '%';
      b.style.setProperty('--dx', (Math.random() * 60 - 30) + 'px');
      b.style.animationDuration = dur + 's';
      layer.appendChild(b);
      setTimeout(function () { b.remove(); }, dur * 1000);
    }
    for (var i = 0; i < (mobile ? 10 : 16); i++) setTimeout(spawn, i * 250);
    setInterval(spawn, mobile ? 450 : 300);
  }

  function addShine() {
    var cards = document.querySelectorAll('.nca-prod,.nca-cat,.card-wrapper .card__inner');
    for (var i = 0; i < cards.length; i++) {
      if (cards[i].classList.contains('pda-shine')) continue;
      cards[i].classList.add('pda-shine');
      cards[i].style.setProperty('--sd', (i % 6) * 0.9 + 's');
    }
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('button[name="add"],.product-form__submit,.shopify-payment-button__button,.nca-btn--primary');
    if (!btn) return;
    var r = btn.getBoundingClientRect();
    for (var i = 0; i < 16; i++) {
      var p = document.createElement('span');
      var s = 10 + Math.random() * 18;
      p.className = 'pda-pop';
      p.style.width = p.style.height = s + 'px';
      p.style.left = (r.left + Math.random() * r.width) + 'px';
      p.style.top = (r.top + r.height / 2) + 'px';
      p.style.setProperty('--px', (Math.random() * 120 - 60) + 'px');
      p.style.setProperty('--py', (-40 - Math.random() * 90) + 'px');
      document.body.appendChild(p);
      (function (el) { setTimeout(function () { el.remove(); }, 950); })(p);
    }
  }, true);

  function run() {
    var zones = document.querySelectorAll('.nca-hero,.collection-hero__inner,.nca-cta__box');
    for (var i = 0; i < zones.length; i++) addBubbles(zones[i]);
    addShine();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
  setTimeout(addShine, 2500);
})();
